var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uBAA9\\uB85D\\uD615",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.494,
    height: 16.513,
    viewBox: "0 0 18.494 16.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC120_9",
    "data-name": "\\uC120 9",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.321H18.494",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.49405288696289 2.64200758934021 L -1.173287062767963e-15 2.64200758934021 L -1.173287062767963e-15 0 L 18.49405288696289 0 L 18.49405288696289 2.64200758934021 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC120_10",
    "data-name": "\\uC120 10",
    transform: "translate(0 4.624)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.321H18.494",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.49405288696289 2.64200758934021 L -1.173287062767963e-15 2.64200758934021 L -1.173287062767963e-15 0 L 18.49405288696289 0 L 18.49405288696289 2.64200758934021 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC120_11",
    "data-name": "\\uC120 11",
    transform: "translate(0 9.247)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.321H18.494",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.49405288696289 2.64200758934021 L -1.173287062767963e-15 2.64200758934021 L -1.173287062767963e-15 0 L 18.49405288696289 0 L 18.49405288696289 2.64200758934021 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC120_12",
    "data-name": "\\uC120 12",
    transform: "translate(0 13.871)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.321H18.494",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.49405288696289 2.64200758934021 L -1.173287062767963e-15 2.64200758934021 L -1.173287062767963e-15 0 L 18.49405288696289 0 L 18.49405288696289 2.64200758934021 Z",
    stroke: "none",
    fill: "#1d333e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.4ec045fcdfc7ce474314481bacfe14f0.svg";
export { ForwardRef as ReactComponent };